import React, { useState } from 'react'
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/hooks';
import { PAGE_NUMBER, PAGE_SIZE } from '../../utils/constants';
import { useGetStudentsCertificates } from '../../hooks/useGetStudentCertificate';
import TableComponent from '../../components/common/Tables';
import { Lists } from '../../components/common/Lists';
import { EyeOpenIcon } from '@radix-ui/react-icons';
import toast from 'react-hot-toast';
import { getStudentCertificate } from '../../services/school/student/getStudentByCode';
import { useExportDocument } from '../../hooks/useExportDocument';
import { resetLoaderAvailable, setLoaderAvailable } from '../../redux/slices/loaderController';

const columnNamesMap: { [key: string]: string } = {
  // id: 'Nome',
  student: 'Estudante',
  studentCode: 'Código',
  course: 'Curso',
  level: 'Nivel',
  // type: 'Tipo',

};
export const StudentCertificates = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { downloadOnly } = useExportDocument();
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetStudentsCertificates({ PageNumber: currentPage, PageSize: pageSize, SearchTerm: searchTerm });
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(PAGE_NUMBER);
  };

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };
  const handleDownload = async (c: any) => {
    try {
      dispatch(setLoaderAvailable(true));
      const data = await getStudentCertificate({
        id: c.studentId, type: c.type, courseId: c.courseId
      });
      const blob = new Blob([data], { type: 'application/pdf' });

      downloadOnly(blob, c.type);

    } catch (error) {
      toast.error(`Erro ao carregar o certificado: ${error}`);
    } finally {
      dispatch(resetLoaderAvailable())
    }
  }

  const options = data?.items.map(() => [
    {
      label: 'Download',
      onClick: (c: any) => handleDownload(c),
      icon: <EyeOpenIcon />
    }
  ]) || [];

  return (
    <>
      <Lists
        status={status}
        TableComponent={() =>
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            onSearch={handleSearch}
            search={searchTerm}
            totalItems={data?.totalItems || 0}
          />
        }
        handleClickCreate={undefined}
      />


    </>
  );
}


